import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Track Orders',
  description:
    'Easily track your shipments with ShipSkis. Get real-time updates and notifications.',
  alternates: {
    canonical: 'https://www.shipskis.com/track-orders',
  },
}

export default metadata
